import script from "./ProjectCardProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectCardProperties.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectCardProperties.vue?vue&type=style&index=0&id=2ad5c2de&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ad5c2de"]])

export default __exports__